import { render, staticRenderFns } from "./pv-chat.vue?vue&type=template&id=32b52024&"
import script from "./pv-chat.vue?vue&type=script&setup=true&lang=js&"
export * from "./pv-chat.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports